import { InsightTab } from "../../components/insight_tab";
import { InsightTabProps } from "../../models/insight_tab";
import { RAJ_DATA } from "./Data";

export function InsightTabTest() {
  const insightTab: InsightTabProps = {
    title: "Insight Tab",
    data: RAJ_DATA.map((item) => ({
      ...item,
     type: item.value_mw > 0 ? "Buy" : "Sell",
     value_mw: Math.abs(item.value_mw),
    })),
    keys: {
      xAxis: [
        {
          label: "Time Block",
          keys: ["time_slot", "date"],
          isTime: true,
        },
        {
          label: "Date",
          keys: ["date"],
        },
        {
          label: "Month",
          keys: ["month"],
        },
      ],
      groupBy: [
        {
          label: "Exchange",
          keys: ["exchange__name", "type"],
        },
        {
          label: "Product",
          keys: ["product__name", "type"],
        },
      ],

      vol_mw: "value_mw",
      extra_vol_mw: [],
      price_rs_kwh: "wt_mcp_rs_kwh",
    },
    filters: {
      xAxis: true,
      groupBy: true,
      search: [],
      extraFilters: [],
    },
  };
  return (
    <div className="page-wrapper">
      <InsightTab insightTab={insightTab} />
    </div>
  );
}
